import { render, staticRenderFns } from "./so-week-tile.vue?vue&type=template&id=dadcd1de"
import script from "./so-week-tile.vue?vue&type=script&lang=js"
export * from "./so-week-tile.vue?vue&type=script&lang=js"
import style0 from "./so-week-tile.vue?vue&type=style&index=0&id=dadcd1de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports